import script from "./CreditAvailabilityNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreditAvailabilityNotice.vue?vue&type=script&setup=true&lang=ts"

import "./CreditAvailabilityNotice.vue?vue&type=style&index=0&id=6cfca118&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cfca118"]])

export default __exports__